import { writable } from "svelte/store";
export const CURRENT_PURCHASE_PAYMENT = writable(false);
export const CURRENT_PURCHASE_PRODUCT = writable({});
export const LATEST_PURCHASE = writable('');
export const LATEST_PURCHASE_WITH_CLEARANCE_ACTION = writable('');
export const LATEST_PURCHASE_WITH_PAYMENT_ACTION = writable('');
